import { notiDataService } from "./services";
import { FancyCard } from "./components";
import { faMessage } from "@fortawesome/free-solid-svg-icons";
import { ModuleTypeEnum } from "../../enums";
import { IModuleConfig } from "../../interfaces";
import { BackButton } from "../notification-module/components/toolbar-items";
import { ItemPage } from "../notification-module/components";
import SendButton from "./components/toolbar-items/SendButton";
import {UserPermissions} from "../../definitions"

const config: IModuleConfig = {
  id: "notification",
  name: "Custom Notifications",
  view_permission: UserPermissions.viewCustomNotifications,
  edit_permission: UserPermissions.editCustomNotifications,
  icon: faMessage,
  moduleType: ModuleTypeEnum.DualPaneLibrary,
  allowSearch: true,
  components: {
    libraryCard: FancyCard,
    itemPage: ItemPage
  },
  services: {
    getByPage: notiDataService.getByPage,
    getSingle: notiDataService.getSingle
  },
  utilities: {
    extractKey: (d: any) => d.name,
    extractItemPath: (d: any) => d._id,
    extractItemBreadcrumb: (d: any) => `${d._id}`
  },
  toolbarItems: {
    library: [],
    create: [BackButton],
    edit: [],
    view: [BackButton, "|", SendButton]
  }
};

export default config;
